<template>
    <!-- <van-overlay :show="showTip" :lock-scroll="false" @click="showTip = false" z-index="3001"> </van-overlay> -->
    <GeneralDialog v-model="showTip" title="Bonus">
        <div class="dialog" @click.stop>
            <div class="pic">
                <img src="@/assets/img/wallets/bonus_pop_bg.png" />
                <p class="pic-text">{{ $t('bet') }}</p>
            </div>
            <div class="content" v-html="content"></div>
            <div class="confirm" @click="showTip = false">{{ $t('Confirm') }}</div>
        </div>
    </GeneralDialog>
</template>
<script setup lang="ts">
import GeneralDialog from '@/components/dialog/generalDialog.vue'
defineProps({
    title: {
        type: String,
        default: () => '',
    },
    content: {
        type: String,
        default: () => '',
    },
})

const showTip = defineModel()
</script>
<style lang="scss" scoped>
.dialog {
    @apply flex flex-col;
    width: 700px;
    min-height: 690px;
    padding: 0 29px 60px 26px;
    border-radius: 30px;
    background-color: #2a2d3d;
    color: #ffffff;

    .pic {
        @apply flex justify-center items-center relative;
        margin-top: 30px;
        width: 645px;
        height: 268px;
        border-radius: 20px;
        background: linear-gradient(85deg, #613679 3.85%, #3b2a4a 96.05%);

        img {
            width: 519px;
            height: 177px;
        }
        .pic-text {
            position: absolute;
            bottom: 60px;
            color: #fe588a;
            font-size: 45px;
            font-weight: 700;
            transform: translateX(-10%);
        }
    }

    .content {
        margin: 38px 0 48px;
        padding: 0 10px;
        flex: 1;
        overflow-y: scroll;
        font-size: 30px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 60px;
        letter-spacing: -1px;
    }
    .confirm {
        margin: 20px auto 0;
        width: 493px;
        height: 92px;
        line-height: 92px;
        border-radius: 100px;
        background: var(--, linear-gradient(0deg, #fa3374 0%, #ff7aa5 100%));
        color: #fff;
        text-align: center;
        font-size: 44px;
        font-weight: 600;
    }
}
</style>
